import { ModuleDisplayTypeEnum, ModuleEnum } from "@resource/common";

type ModuleDisplayInfoType = {
  [key in ModuleEnum]: {
    header: string;
    description: string;
    displayType: string;
  };
};

const ModuleDisplayInfo: ModuleDisplayInfoType = Object.freeze({
  [ModuleEnum.GreetingHeader]: {
    header: "Greeting",
    description: "Welcome candidates with a personalized greeting.",
    displayType: ModuleDisplayTypeEnum.GreetingHeader,
  },
  [ModuleEnum.Time]: {
    header: "Interview Time",
    description: "Display a summary of upcoming interviews.",
    displayType: ModuleDisplayTypeEnum.Time,
  },
  [ModuleEnum.Location]: {
    header: "Location",
    description: "Add an address with instructions and a map.",
    displayType: ModuleDisplayTypeEnum.Location,
  },
  [ModuleEnum.Mission]: {
    header: "Company Mission",
    description: "Share your company's purpose.",
    displayType: ModuleDisplayTypeEnum.Mission,
  },
  [ModuleEnum.CandidatePostInterviewFeedback]: {
    header: "Interview Feedback",
    description:
      "Candidates provide simple feedback about their last interview",
    displayType: ModuleDisplayTypeEnum.CandidatePostInterviewFeedback,
  },
  [ModuleEnum.Links]: {
    header: "Links",
    description: "Share links as clickable cards.",
    displayType: ModuleDisplayTypeEnum.Links,
  },
  [ModuleEnum.Values]: {
    header: "Company Values",
    description: "Share the principles & beliefs that guide your company.",
    displayType: ModuleDisplayTypeEnum.InfoCards,
  },
  [ModuleEnum.TeamPhoto]: {
    header: "Image",
    description: "Upload an image or gif.",
    displayType: ModuleDisplayTypeEnum.TeamPhoto,
  },
  [ModuleEnum.Media]: {
    header: "Video",
    description: "Share a YouTube or Loom video.",
    displayType: ModuleDisplayTypeEnum.Media,
  },
  [ModuleEnum.Logistics]: {
    header: "Tips",
    description: "Set candidates up for success.",
    displayType: ModuleDisplayTypeEnum.InfoCards,
  },
  [ModuleEnum.Chat]: {
    header: "In-Guide Chat",
    description:
      "A super simple way for candidates to ask questions via their Guide",
    displayType: ModuleDisplayTypeEnum.Chat,
  },
  [ModuleEnum.InterviewScheduler]: {
    header: "Scheduler",
    description: "Let your candidates self-schedule interviews with you.",
    displayType: ModuleDisplayTypeEnum.InterviewScheduler,
  },
  [ModuleEnum.InterviewProcess]: {
    header: "Interview Tracker",
    description:
      "Give candidates a peek into what their interview process will be like.",
    displayType: ModuleDisplayTypeEnum.InterviewProcess,
  },
  [ModuleEnum.Schedule]: {
    header: "Schedule",
    description: "Display a schedule of upcoming interviews.",
    displayType: ModuleDisplayTypeEnum.Schedule,
  },
  [ModuleEnum.InterviewTeam]: {
    header: "Interview team",
    description: "Showcase interviewers and link to their profiles.",
    displayType: ModuleDisplayTypeEnum.InterviewTeam,
  },
  [ModuleEnum.RichText]: {
    header: "Text",
    description: "Paragraphs, lists, links, and more rich text options.",
    displayType: ModuleDisplayTypeEnum.RichText,
  },
  [ModuleEnum.Assessment]: {
    header: "Assessment",
    description: "Add a clickable button with a customizable link.",
    displayType: ModuleDisplayTypeEnum.Assessment,
  },
  [ModuleEnum.Offer]: {
    header: "Offer",
    description: "Share salary and compensation details.",
    displayType: ModuleDisplayTypeEnum.Offer,
  },
});

export default ModuleDisplayInfo;
